import CheckboxFormControl from './CheckboxFormControl';

export { LabelPosition } from './CheckboxFormControl';

export default CheckboxFormControl;
